import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 -0.5 25 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.97 16.47a.75.75 0 1 0 1.06 1.06zm6.06-3.94a.75.75 0 1 0-1.06-1.06zm-1.06-1.06a.75.75 0 1 0 1.06 1.06zm6.06-3.94a.75.75 0 0 0-1.06-1.06zm-5 3.94a.75.75 0 1 0-1.06 1.06zm3.94 6.06a.75.75 0 1 0 1.06-1.06zm-5-5a.75.75 0 1 0 1.06-1.06zM8.03 6.47a.75.75 0 0 0-1.06 1.06zm0 11.06 5-5-1.06-1.06-5 5zm5-5 5-5-1.06-1.06-5 5zm-1.06 0 5 5 1.06-1.06-5-5zm1.06-1.06-5-5-1.06 1.06 5 5z"
    }, null, -1)
  ])))
}
export default { render: render }